// APP CONSTATNS
const app = {
    DEBUG: false,
    MOCK: false,
    APP_NAME: 'Clever Tykes',
    PAYPAL_EMAIL: 'info@clevertykes.com',

    API_URL: 'https://api.clevertykes.com/api/',
    API_URL_DEV: 'http://clever-tykes.dev/api/',

    GOOGLE_ANALYTICS_ID: 'UA-42397349-1',
    // VAPID https://github.com/web-push-libs/web-push-php#authentication-vapid
    WEB_PUSH_PUBLIC_KEY: 'BHlei9YZWDoyjbl5bTzUqjZ4f8uVMsyUL8l-IZnpR8UMJHarMa-dC9XjRh1u6cvaaaTHk2-UDpCzQWD4KZE3zh0',

    AUTH_KEY: 'clevertykes-key',
    INTRO_DONE: 'clevertykes-intro-done'
};

export default app;



/** WEBPACK FOOTER **
 ** ./src/core/constants.js
 **/